<template>
  <div>
    <div class="row mt-4 pt-4">
      <div class="col-12 col-md-6">
        <!-- v-model="scheduledVisit.date" -->
        <hl-Datepicker label="Visningsdato" v-model="viewing.date" name="rent.startDate" v-validate></hl-Datepicker>
      </div>
      <div class="col-6 col-md-3 mt-4 mt-md-0">
        <!-- v-model="scheduledVisit.timeFrom" -->
        <hl-Input
          type="time"
          label="Fra klokken"
          placeholder="09:30"
          v-model="viewing.timeFrom"
          v-validate
          name="rentalObject.floor"
        ></hl-Input>
      </div>

      <div class="col-6 col-md-3 mt-4 mt-md-0">
        <!-- v-model="scheduledVisit.timeTo" -->
        <hl-Input
          type="time"
          label="Til klokken"
          placeholder="09:30"
          v-model="viewing.timeTo"
          v-validate
          name="rentalObject.floor"
        ></hl-Input>
      </div>
    </div>
    <div class="mt-4 mb-5">
      <!-- v-model="scheduledVisit.details" -->
      <hl-Textarea
        label="Merknad for visning"
        v-model="viewing.message"
        placeholder="Eksempel: retningsveiledning, kontaktinfo, navn på ringeklokke etc."
      ></hl-Textarea>
    </div>
  </div>
</template>

<script>
import Input from '@modules/husleie-framework/src/components/forms/inputs/input/Input.vue';
import Datepicker from '@modules/husleie-framework/src/components/forms/inputs/Datepicker.vue';
import Textarea from '@modules/husleie-framework/src/components/forms/Textarea.vue';

export default {
  components: {
    'hl-Input': Input,
    'hl-Datepicker': Datepicker,
    'hl-Textarea': Textarea,
  },

  data() {
    return {
      viewing: {
        date: '',
        timeFrom: '',
        timeTo: '',
        message: '',
      },
    };
  },

  watch: {
    viewing: {
      deep: true,
      handler(value) {
        this.$emit('updated', value);
      },
    },
  },
};
</script>
